<list-view *ngIf="listeServices" [liste]="listeServices"></list-view>

<list-view *ngIf="listeUtilisateurs" [liste]="listeUtilisateurs"></list-view>